import { Component } from '@angular/core';

@Component({
  selector: 'svc-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  activeSection = 'service-mapping';
}
